import { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { theme } from '../../../theme/theme';

import wifichannels from '../../../data/wifichannels.json';

const OperatingRegionSelect = (props) => {

  const [wifiRegion, setOperatingRegion] = useState(props.wifiRegion);

  const handleOperatingRegionChanged = (event) => {
    setOperatingRegion(event.target.value);
    if (props.onChange) {
      props.onChange({"wifiRegion": event.target.value});
    } else {
      console.error("OperatingRegion changed handler not defined");
    }
  };

  useEffect(() => {
    setOperatingRegion(props.wifiRegion);
  }, [props.wifiRegion]);

  return (
    <TextField 
      select
      onChange={handleOperatingRegionChanged}
      disabled={props.disabled}
      value={wifiRegion ?? ''}
      fullWidth
      sx={{ 
        "& .MuiOutlinedInput-root":{"& > fieldset": {borderColor: theme.palette.secondary.main}},
        "& .MuiOutlinedInput-input":{color: 'white'},
        "& .MuiOutlinedInput-input.Mui-disabled":{WebkitTextFillColor: 'white'},
        "& .MuiSelect-icon":{color: 'white'},
        "& .Mui-disabled":{"& > .MuiSelect-icon": {color: 'inherit'}},
        textAlignLast: 'end'
      }}
    >
      {Object.entries(wifichannels)?.sort((t1, t2) => {
        var [, el1_val] = t1;
        var [, el2_val] = t2;

        return el1_val.Name < el2_val.Name ? -1 : 1;
      }).map(([key, value]) => {
        return <MenuItem key={key} value={key}>{value.Name}</MenuItem>;
      })}
    </TextField>
  );
};

export default OperatingRegionSelect;